import _toConsumableArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*
 * Value is different, when it's multi select or not.
 * Multi-select: Array<Object>
 * Single-slect: Object
 *
 * Transform values into Array<Objecy> for both cases.
 */
export var getValues = function getValues(value, isMulti) {
  if (!value) return [];
  var values = isMulti ? value : [value];
  var filteredValues = values.filter(Boolean); // Remove undefined/null

  return filteredValues.length === values.length ? values : filteredValues;
};
export var getValuesToDisplay = function getValuesToDisplay(values, totalCount, maxToJoin) {
  return values.length > maxToJoin ? "".concat(values.length, " of ").concat(totalCount, " selected") : values.map(function (_ref) {
    var label = _ref.label;
    return label;
  }).join(', ');
};
export var flattenOptions = function flattenOptions(options) {
  return options.reduce(function (agg, opt) {
    return opt.options ? [].concat(_toConsumableArray(agg), _toConsumableArray(opt.options)) : [].concat(_toConsumableArray(agg), [opt]);
  }, []);
};
/*
 * Used to select/deselect all options, after filtering.
 * Prevents from losing what was selected before filtering.
 */

export var getFilteredOptionsToToggleSelect = function getFilteredOptionsToToggleSelect(alreadySelected, filteredAlreadySelected, filteredAll) {
  var selectedNotFiltered = alreadySelected.filter(function (option) {
    return !filteredAlreadySelected.includes(option);
  });
  if (filteredAlreadySelected.length === filteredAll.length) return selectedNotFiltered;
  return [].concat(_toConsumableArray(selectedNotFiltered), _toConsumableArray(filteredAll));
};